module.exports = __webpack_public_path__ + "img/invite.c086b8fd.jpg";